import type { FileMap, Dirent } from '.';

export interface DirentWithPath {
  dirent: Dirent;
  path: string;
}

/**
 * Given a FileMap and a path, returns an iterator
 * that returns every files and folder that are contained
 * in the provided path.
 */
export function walkFileMap(files: FileMap, filePath: string): Iterable<DirentWithPath> {
  function* generator(): Generator<DirentWithPath, void, void> {
    const fileOrFolder = files[filePath];

    if (fileOrFolder?.type === 'file') {
      yield { dirent: fileOrFolder, path: filePath };

      return;
    }

    for (const path in files) {
      if (path === filePath || path.startsWith(filePath + '/')) {
        const dirent = files[path];

        if (dirent) {
          yield { dirent, path };
        }
      }
    }
  }

  return generator();
}
